// ────────────────────────────────────────────────────────────────────
// mockTags — DATA-ONLY predicate for "does this asset tag have a bundled
// procedural 3D scene?" (JSM-A demo vessels/tanks + isometric line drawings).
//
// Kept free of three.js so screens can import it EAGERLY to decide whether
// to mount the lazy-loaded AssetMockup3D at all; AssetMockup3D imports
// LINE_DRAWING from here so the two can never disagree.
// ────────────────────────────────────────────────────────────────────

import { getVessel, getTank } from "./mockData";

// JSM-A line tag → the isometric drawing that depicts it. The mock dwgNo embeds
// the line number (…-1234-… → 6"-P-1234, …-2001-… → 8"-G-2001, etc.).
export const LINE_DRAWING: Record<string, string> = {
  "6-P-1234": "dwg-001",
  "8-G-2001": "dwg-003",
  "4-WI-3045": "dwg-004",
  "6-P-1235": "dwg-005",
  "3-GL-4012": "dwg-006",
  "2-CH-5008": "dwg-007",
};

/** True when AssetMockup3D can render a bundled scene for this tag (so the
 *  3D panel is worth mounting even without an uploaded STL). */
export function hasMock3D(tag: string): boolean {
  const id = (tag || "").toLowerCase();
  return Boolean(getVessel(id) || getTank(id) || LINE_DRAWING[tag]);
}
